<span class="title-menu icon ico-cta">Dashboard</span>
<ul class="menu menu-top">
  @for (entry of tabEntries; track $index; let i = $index) {
    <li>
        <a (click)="onSelectTab(i)">{{entry.caption}}</a>?
    </li>
  }
</ul>
